import React from 'react'
import { object, array } from 'prop-types'

import Title from '@/component/Primitive/Title'
import Stack from '@/component/Primitive/Stack'
import ExecutiveCardGrid from '@/component/Primitive/ExecutiveCardGrid'

const ExecutivesInCompanyWidget = ({ pageData, executives }) => {
  if (!executives || !executives.length) return null
  const { company } = pageData
  return (
    <Stack>
      <Title
        title={`Executives in ${company.name}`}
        ctaLabel="View All"
        to="/company/[slug]/executives"
        ctaUrl={`/company/${company.slug}/executives`}
        bordered="default"
      />
      <ExecutiveCardGrid executives={executives} />
    </Stack>
  )
}

ExecutivesInCompanyWidget.propTypes = {
  pageData: object,
  executives: array
}

export default ExecutivesInCompanyWidget
